var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.27 41.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.64,0h0C9.24,0,0,9.24,0,20.64s9.24,20.64,20.64,20.64h0c11.4,0,20.64-9.24,20.64-20.64S32.03,0,20.64,0ZM32.83,15.02c.36,7.95-5.57,16.82-16.07,16.82-3.19,0-6.17-.94-8.67-2.54,3,.35,5.99-.48,8.37-2.34-2.48-.05-4.56-1.68-5.28-3.93.89.17,1.76.12,2.55-.1-2.72-.55-4.6-3-4.54-5.62.76.42,1.63.68,2.56.71-2.52-1.68-3.23-5.01-1.75-7.55,2.79,3.42,6.96,5.67,11.65,5.91-.82-3.54,1.86-6.94,5.51-6.94,1.63,0,3.1.69,4.13,1.79,1.29-.25,2.5-.72,3.59-1.37-.42,1.32-1.32,2.43-2.49,3.13,1.14-.14,2.23-.44,3.25-.89-.76,1.13-1.72,2.13-2.82,2.93Z",
    fill: "#ff9be7",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveTwitter);
export default __webpack_public_path__ + "static/media/activeTwitter.2e80a2d95791aed659ca0e8f3f11e0a4.svg";
export { ForwardRef as ReactComponent };